import React, { useState } from "react";
import * as moment from "moment";
import styled from "styled-components";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";
import { FieldArray } from "formik";
import { useSelector } from 'react-redux';
import NumberInput from "web/components/form-elements/NumberInput";
import DatePickerPTPlus from "web/components/form-elements/DatePickerPTPlus";
import TimePickerInput from "web/components/form-elements/TimePickerInput"
import TextInput from "web/components/form-elements/TextInput";
import AlertModal from "web/components/AlertModal";
import DisabledInput from "web/components/form-elements/DisabledInput";
import PlusRoundIcon from "web/assets/svg/PlusRoundIcon"

const LoadDetails = ({ props, maxQuantityState, editResponse, callBack ,loadsCallBack }) => {
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [modalLink, setModalLink] = useState("/");
    const toggleModal = () => setModal(!modal);

    const [errorMessage, setErrorMessage] = useState("");

    const urlObject = useSelector(
      (state) => state.urlParameters.requestedId
    );

    let loadArr =[]
  
    if(editResponse?.data?.loadDetails){
        loadArr.push(editResponse?.data?.loadDetails)
    }
    

    const addMoreLoads = (item, index, arrayHelpers) => {       
        return <div className="loan-detail-wrapper">
            {/* <Field name={`addMoreArrList.${index}`} /> */}
            <div className="mb-32">               
                <NumberInput
                    name={`addMoreArrList.[${index}].lots`}
                    // name={"lots"+ index}
                    placeholder="No. of Loads"
                    disabled={urlObject?.id?true:false}
                    maxLength="4"
                    showErrorMessages={true}
                    onChangeHandler={(value) => {
                    }}
                />
            </div>
            <div className="mb-32">
               <NumberInput
                    // name={"QuantityLot" + index}
                    name={`addMoreArrList.[${index}].QuantityLot`}
                    placeholder="Quantity Per Loads"
                    maxLength="4"
                    maxQuantity={maxQuantityState}
                    showErrorMessages={true}
                    decimalScale={0}
                    onChangeHandler={(value) => {
                        // if (!value) setQuantityError("Quantity Lot is required.")
                        // else setQuantityError("")

                        // callBack(value)
                        //setQuantityValueState(value);
                    }}
                />
            </div>
              <div className=" mb-32" style={{display:"flex"}}>      
                <DatePickerStyled>           
                    <DatePickerPTPlus
                            // name={"requestDeliveryDate" + index}
                            name={`addMoreArrList.[${index}].requestDeliveryDate`}
                            placeholderText=""
                            editResponse={editResponse}
                            type="createOrder"
                            selectedDate={item?.requestDeliveryDate}
                            disabled={props.values.recurringCheckBoxFlag}
                            callBackFun={(msg) => {
                              loadsCallBack(msg)
                              setErrorMessage(msg)
                            }}
                        />      
                        {errorMessage && <p className="error-message" style={{"margin-top":"5px"}}>{errorMessage}</p>}  
                </DatePickerStyled>
              </div>
            <div className=" mb-32" style={{display:"flex"}}>       
               <div>     
                  <span style={{"font-weight": "bold"}}>From</span> 
                  {urlObject?.id? <TimePickerInput
                      //  name={"appt" + index}
                      name="apptEdit"
                      editResponse={editResponse}
                      showErrorMessages={true}
                      edit={props.values.apptEdit}
                      fromValue={props.values.apptEdit}
                      disabled={props.values.recurringCheckBoxFlag}
                      // toValue={props.values.apptTo}
                      onChangeHandler={(time) => {
                        // if(time >props.values.apptTo){
                        // }
                          if (time === "00:00") {
                              // setModalContent("Please enter correct time.");
                              // setModalLink("");
                              // toggleModal();
                          } 
                      }}
                  />:
                   <TimePickerInput
                   //  name={"appt" + index}
                   name={`addMoreArrList.[${index}].appt`}
                   editResponse={editResponse}
                   showErrorMessages={true}
                   fromValue={props.values.appt}
                   disabled={props.values.recurringCheckBoxFlag}
                   selectedValue={props.values.addMoreArrList[index].appt}
                   // toValue={props.values.apptTo}
                   onChangeHandler={(time) => {
                     // if(time >props.values.apptTo){
                     // }
                       if (time === "00:00") {
                           // setModalContent("Please enter correct time.");
                           // setModalLink("");
                           // toggleModal();
                       } 
                   }}
               />}
                 
                </div> 
                <div style={{"margin-left":"15px"}}>
                  <span style={{"font-weight": "bold"}}>To</span>
                  {urlObject?.id? <TimePickerInput
                      //name={"appt" + index}
                      name="apptToEdit"
                      editResponse={editResponse}
                      // endTime="23:00"
                      // fromValue={props.values.appt}
                      toValue={props.values.apptToEdit}
                      edit={props.values.apptToEdit}
                      showErrorMessages={true}
                      disabled={props.values.recurringCheckBoxFlag}
                      onChangeHandler={(time) => {                        
                          if (time === "00:00") {
                            // setModalContent("Please enter correct time.");
                            // setModalLink("");
                            // toggleModal();
                          } 
                      }}
                  />:
                   <TimePickerInput
                      //  name={"appt" + index}
                      name={`addMoreArrList.[${index}].apptTo`}
                      editResponse={editResponse}
                      endTime="23:00"
                     
                      // fromValue={props.values.appt}
                      toValue={props.values.apptTo}
                      disabled={props.values.recurringCheckBoxFlag}
                      selectedValue={props.values.addMoreArrList[index].apptTo}
                      showErrorMessages={true}
                      onChangeHandler={(time) => {
                        
                          if (time === "00:00") {
                              // setModalContent("Please enter correct time.");
                              // setModalLink("");
                              // toggleModal();
                          } 
                      }}
                  />}
                </div>
            </div>

            <div className="mb-32">
                    <TextInput
                        // name={'poNumber' + index}
                        name={`addMoreArrList.[${index}].poNumber`}
                        placeholder="PO#"
                        inputType={"poNumber"}
                        maxLength='20'
                        showErrorMessages={true}
                    />
            </div>         
                  {props.values.addMoreArrList.length >1 && props.values.addMoreArrList.length-1 !== index && <><button
                    type="button"
                    className="mb-32"
                    onClick={() =>{
                        arrayHelpers.remove(index)
                    }} // remove a friend from the list
                  >
                    Remove
                  </button>
                  </>}

                  {props.values.addMoreArrList.length-1 === index && !urlObject?.id ? <button
                    type="button"
                    className="add-more mb-32" 
                    style={{background: props.values.recurringCheckBoxFlag && '#a9a9a9'}}
                    disabled={props.values.recurringCheckBoxFlag}
                    onClick={() =>{
                      //   if (!props.values.addMoreArrList[index].lots) {
                      //       setModalContent("Load is required.");
                      //       setModalLink("");
                      //       toggleModal();
                      //       return false
                      //   }
                      //   if (!props.values.addMoreArrList[index].QuantityLot) {
                      //       setModalContent("Quantity per load is required.");
                      //       setModalLink("");
                      //       toggleModal();
                      //       return false
                      //   }
                      //   if (props.values.addMoreArrList[index].appt === "00:00") {
                      //       setModalContent("Please enter correct time.");
                      //       setModalLink("");
                      //       toggleModal();
                      //       return false
                      //   }
                      //   if (props.values.addMoreArrList[index].apptTo === "00:00") {
                      //     setModalContent("Please enter correct time.");
                      //     setModalLink("");
                      //     toggleModal();
                      //     return false
                      // }
                        let obj={
                            lots:"",
                            QuantityLot:props.values.addMoreArrList[index].QuantityLot || props.values.QuantityLot,
                            requestDeliveryDate:props.values.requestDeliveryDate,
                            appt:props.values.appt,
                            apptTo:props.values.apptTo,
                            poNumber:""
                          }
                        arrayHelpers.push(obj)
                        // arrayHelpers.push(index, "")
                    }} // insert an empty string at a position
                  >
                    <PlusRoundIcon />Add More
                  </button>
                  :<>{urlObject?.id && <button
                    type="button"
                    className="add-more-disable mb-32" 
                    onClick={() =>{                     

                    }} // insert an empty string at a position
                  >
                    <PlusRoundIcon />Add More
                  </button>}</>
                }
        </div>
    }
    const fieldArray=()=>{
        return <FieldArray
        name="addMoreArrList"
        render={arrayHelpers => (
          <div>           
            {props.values.addMoreArrList && props.values.addMoreArrList.length > 0 &&  (
              props.values.addMoreArrList.map((item, index) => (
                <div key={index}>           
                  {addMoreLoads(item, index, arrayHelpers)}                
                </div>
              ))
            ) 
            }
             {/* <div>
                  <button type="submit" onClick={()=>{
                  }}>Submit</button>
                </div> */}
          </div>
        )}
      />
    }
    return (
        <>
            <div className="loan-detail-wrapper">
                <div className="label-heading mt-24">
                    <p>Load Details<span className="star">*</span></p>
                </div>
                <div></div>
                <div className="label-heading mt-24">
                    <p>Delivery Date<span className="star">*</span></p>
                </div>
                <div className="label-heading mt-24">
                    <p>Appointment Window<span className="star">*</span></p>
                </div>
            </div>
           
            {fieldArray()}

            <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title="Alert"
            content={modalContent}
            link={modalLink}
            className="alert-msg-container"
            InnerClassName="alert-msg"
          />
        </>
    )
};

export default LoadDetails;

const DatePickerStyled = styled.div`
  height: 53px;
  padding-top: 18px;
  width: 100%;
  .file-input-wrapper .MuiFormControl-root .MuiInput-root {
    padding-left: 0;
    padding-right: 0;
  }
`;